import React from "react";
import { useParams } from "react-router-dom";
import ClockScreen from "./ClockScreen";

export default function Kiosk() {
  const { companyId } = useParams();
  return <ClockScreen mode="kiosk" fixedCompanyId={companyId} />;
}
